import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import './Portfolio.css';

const Portfolio = () => {
  return <div>This is Portfolio</div>;
};

export default Portfolio;
